/** Osoby nabízené při přidávání do složky - navíc oproti getPersonsFrag nese pole pro rozlišení jmenovců. */
export const folderPersonSearchFrag = `
    id
    titleBeforeName
    titleAfterName
    name
    surname
    birthSurname
    alias
    image
    sex
    birthdate
    insuranceNumber
    dateDeath
`;
